import {getAxiosInstance, requestConfig} from "../../http-common";
import { CreateMigrationRuleMapping } from "../../models/migrationrules/CreateMigrationRuleMapping";
import { UpdateMigrationRuleMapping } from "../../models/migrationrules/UpdateMigrationRuleMapping";

const RESOURCE_NAME = "mappings";

const getAll = (groupCode: string, entity: string) => {
    const http = getAxiosInstance();
    return http.get(`${RESOURCE_NAME}/GetAll?groupCode=${groupCode}&entity=${entity}`, requestConfig());
};

const getAllUnfinished = () => {
  const http = getAxiosInstance();
  return http.get(`${RESOURCE_NAME}/GetAllUnfinished`, requestConfig());
};

const create = (model: CreateMigrationRuleMapping) => {
  const http = getAxiosInstance();
  return http.post(`${RESOURCE_NAME}`, model, requestConfig());
};

const createMultiple = (model: Array<CreateMigrationRuleMapping>) => {
  const http = getAxiosInstance();
  return http.post(`${RESOURCE_NAME}/CreateMultiple`, model, requestConfig());
};

const update = (model: UpdateMigrationRuleMapping) => {
  const http = getAxiosInstance();
  return http.put(`${RESOURCE_NAME}/${model.mappingId}`, model, requestConfig());
};

const remove = (id:number) => {
  const http = getAxiosInstance();
  return http.delete(`${RESOURCE_NAME}/${id}`, requestConfig());
};

const MappingService = {
  getAll,
  getAllUnfinished,
  create,
  createMultiple,
  update,
  remove,
};
export default MappingService;
